import { Component, OnInit, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule, DatePipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { PlayerService } from '../../../shared/services/player.service';
import { Player } from '../../../shared/models/player.model';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PositionPipe } from '../../../shared/pipes/position.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-player-search',
    templateUrl: './player-search.component.html',
    styleUrls: ['./player-search.component.css'],
    imports: [
      CommonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatOption,
      MatButtonModule,
      MatToolbarModule,
      MatTableModule,
      MatPaginatorModule,
      MatSortModule,
      MatIconModule,
      MatTooltipModule,
      MatProgressSpinnerModule,
      RouterLink,
      DatePipe,
      PositionPipe,
      TranslatePipe
    ]
})
export class PlayerSearchComponent implements OnInit {

  private readonly desktopColumns: string[] = ['Player', 'DateOfBirth', 'Position', 'actions'];
  private readonly mobileColumns: string[] = ['Player', 'Position', 'actions'];
  displayedColumns: string[] = this.desktopColumns;
  dataSource = new MatTableDataSource<Player>([]);
  hasSearched = false;
  showSearchFields = true;
  isSearching = false;
  private paginator: MatPaginator | null = null;

  @ViewChild(MatSort, {static: false}) sort: MatSort | null = null;
  @ViewChild(MatPaginator)
  set matPaginator(paginator: MatPaginator | undefined) {
    if (!paginator) {
      return;
    }

    this.paginator = paginator;
    this.dataSource.paginator = paginator;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event): void {
    const width = (event.target as Window).innerWidth;
    this.updateDisplayedColumns(width);
  }

  private updateDisplayedColumns(width: number): void {
    this.displayedColumns = width <= 430 ? this.mobileColumns : this.desktopColumns;
  }

  searchForm: FormGroup;

  
  constructor(
    public playerRep: PlayerService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { 

  }

  ngOnInit() {
    this.searchForm = new UntypedFormGroup({
      FirstName: new UntypedFormControl(''),
      LastName: new UntypedFormControl('', Validators.required),
      PositionIds: new UntypedFormControl(''),
      
    });

    this.updateDisplayedColumns(window.innerWidth);
  }

  toggleSearchFields() {
    this.showSearchFields = !this.showSearchFields;
  }
 


  searchPlayers(){
    if (this.searchForm.invalid || this.isSearching) {
      return;
    }

    this.isSearching = true;
    this.playerRep.searchPlayers(this.searchForm.value).subscribe({
      next: (result) => {
        this.hasSearched = true;
        this.dataSource.data = result ?? [];
        this.dataSource.sort = this.sort;

        if (this.paginator) {
          this.paginator.firstPage();
        }

        this.showSearchFields = false;
        this.isSearching = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        // console.error('Search error:', err);
        this.isSearching = false;
        this.cdr.detectChanges();
      }
    });
  }

  goToPlayerDetails(playerId: string) {
    this.router.navigate(['/player/details', playerId]);
  }

  createNewReport(playerId: string) {
    this.router.navigate(['/scouting/newreport', playerId]);
  }

}
